/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { vrsSummation } from '../../utils/objectHelpers';

const PointSummation = ({ stories }) => (
  <div>
    <strong>
      {stories.length} Item{stories.length === 1 ? '' : 's'}
    </strong>
    -
    <strong>
      {vrsSummation(stories).size} pt
      {vrsSummation(stories).size === 1 ? '' : 's'}
    </strong>
  </div>
);

PointSummation.propTypes = {
  stories: PropTypes.array
};

export default PointSummation;
